import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Button } from '../../../components/ui/button';
import { AlertTriangle, Save } from 'lucide-react';

export function MaintenanceSettings({ data, setData, isSaving, onSave }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-bold text-slate-900 font-[Poppins]">Maintenance Mode</h3>
          <p className="text-sm text-slate-500 mt-1">
            Enable maintenance mode to restrict access for customers and providers
          </p>
        </div>
        <div className={`px-3 py-1.5 rounded-full text-sm font-medium ${
          data.enabled 
            ? 'bg-red-100 text-red-700' 
            : 'bg-green-100 text-green-700'
        }`}>
          {data.enabled ? 'Maintenance Active' : 'Site Online'}
        </div>
      </div>

      {/* Enable/Disable Toggle */}
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl mb-6">
        <div>
          <p className="font-medium text-slate-900">Enable Maintenance Mode</p>
          <p className="text-sm text-slate-500">
            When enabled, only admins and managers can access the site
          </p>
        </div>
        <Switch
          checked={data.enabled}
          onCheckedChange={(checked) => setData(prev => ({ ...prev, enabled: checked }))}
          data-testid="maintenance-toggle"
        />
      </div>

      <div className="space-y-4">
        <div>
          <Label>Maintenance Title</Label>
          <Input
            placeholder="Under Maintenance"
            value={data.title}
            onChange={(e) => setData(prev => ({ ...prev, title: e.target.value }))}
            className="h-12 mt-1.5"
            data-testid="maintenance-title"
          />
        </div>

        <div>
          <Label>Maintenance Message</Label>
          <textarea
            placeholder="We're currently performing scheduled maintenance..."
            value={data.message}
            onChange={(e) => setData(prev => ({ ...prev, message: e.target.value }))}
            className="w-full h-24 px-4 py-3 mt-1.5 border border-stone-200 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-amber-500"
            data-testid="maintenance-message"
          />
        </div>

        <div className="p-4 bg-amber-50 rounded-xl">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5" />
            <div>
              <p className="font-medium text-amber-900">Important</p>
              <p className="text-sm text-amber-700 mt-1">
                When maintenance mode is enabled, only <strong>Admin</strong> and <strong>Manager</strong> accounts 
                can access the dashboard. Customers and Providers will see the maintenance message.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Button 
        onClick={onSave}
        disabled={isSaving}
        className={`mt-6 ${data.enabled ? 'bg-red-600 hover:bg-red-700' : 'bg-slate-900 hover:bg-slate-800'}`}
        data-testid="save-maintenance-btn"
      >
        <Save className="w-4 h-4 mr-2" />
        {isSaving ? 'Saving...' : data.enabled ? 'Enable Maintenance Mode' : 'Save Settings'}
      </Button>
    </div>
  );
}
